import React from 'react';
import ButtonMore from './ButtonMore.react';
import onClickOutside from 'react-onclickoutside';
import DropdownMenuList from './DropdownMenuList.react';

class DropdownMenu extends React.Component {
  state = {
    isOpen: false,
  };

  // https://github.com/Pomax/react-onclickoutside
  handleClickOutside = (e) => {
    this.close();
  };

  render() {
    const self = this;

    const list = function () {
      if (!self.state.isOpen) {
        return null;
      }

      // this.props.children piekabina close()
      const childrenWithProps = React.Children.map(self.props.children, child => React.cloneElement(child, { closeDropdownMenu: self.close }));

      return (
        <DropdownMenuList
          items={childrenWithProps}
          onClickOutside={self.close}
        />
      );
    };

    return (
      <div className="dropdownMenu dib">
        <ButtonMore onClickButton={this._onToggle} />
        {list()}
      </div>
    );
  }

  /**
  * Aizvērt
  */
  close = () => {
    this.setState({ isOpen: false });
  };

  /**
  * Event handler for 'onToggle'
  */
  _onToggle = () => {
    // toggle
    this.setState({ isOpen: !this.state.isOpen });
  };
}

module.exports = onClickOutside(DropdownMenu);
